<template>
	<form @submit.prevent>
		<UIShInputText
			required
			lg
			:xl="1920"
			name="name"
			label="Имя"
			v-model="nameField.value.value"
			:error="nameField.errorMessage.value"
		/>

		<UIShInputText
			required
			lg
			:xl="1920"
			name="phone"
			label="Телефон"
			mask="+7(###) ###-##-##"
			v-model="phoneField.value.value"
			:error="phoneField.errorMessage.value"
		/>

		<UIShInputText
			required
			lg
			:xl="1920"
			name="email"
			label="Email"
			v-model="emailField.value.value"
			:error="emailField.errorMessage.value"
		/>

		<UIShCheckbox
			label="Я соглашаюсь с Политикой конфиденциальности"
			v-model="checkField.value.value"
			lg
			xl1440
		/>

		<p
			v-if="submitResult.submitted"
			:class="[submitResult.success ? 'success' : 'error']"
		>
			{{ submitResult.message }}
		</p>

		<UIShButton
			v-else
			type="submit"
			label="Отправить"
			kind="secondary-gray"
			class="btn-submit"
			md
			:xl="1920"
			:disabled="!canSubmit"
			@click.prevent="onSubmit"
		/>
	</form>
</template>

<script setup lang="ts">
import { API_RESPONSE } from '@/common/constants';

const triggers = useYmTriggers();
const loading = useLoadingIndicator();
const runtimeConfig = useRuntimeConfig();

const {
	handleSubmit,
	nameField,
	phoneField,
	emailField,
	checkField,
	canSubmit,
	handleReset
} = useFeedbackForm();

const submitResult = ref({ submitted: false, success: false, message: '' });

const onSubmit = handleSubmit(async () => {
	try {
		loading.start();
		submitResult.value.submitted = false;
		const utm = useNuxtApp().$getUtmData();

		await $fetch('/api/local/siteCalls', {
			baseURL: runtimeConfig.public.API_URL,
			method: 'POST',
			body: {
				name: nameField.value.value,
				phone: phoneField.value.value,
				siteName: runtimeConfig.public.NUXT_PUBLIC_SITE_URL,
				...utm
			}
		});

		triggers.hitCallMe();

		submitResult.value.submitted = true;
		submitResult.value.success = true;
		submitResult.value.message = API_RESPONSE.success;

		handleReset();
	} catch (error) {
		submitResult.value.submitted = true;
		submitResult.value.success = false;
		submitResult.value.message = API_RESPONSE.error;
	} finally {
		loading.finish();
		setTimeout(() => {
			submitResult.value.submitted = false;
		}, 3000);
	}
});
</script>

<style lang="scss" scoped>
form {
	display: flex;
	flex-direction: column;
	gap: 0.889rem;
	border-radius: 1.111rem;
	padding: 0.889rem;
	background-color: var(--color-white);
}

.btn-submit {
	width: 100%;
}

.error {
	@include useFont(tsmm);
	color: var(--color-error600);
}

.success {
	@include useFont(tsmm);
	color: var(--color-success700);
}

@include screen1920 {
	form {
		gap: 1.111rem;
		border-radius: 1.333rem;
		padding: 1.778rem;
		width: 30.667rem;
	}

	.btn-submit {
		width: fit-content;
	}
}
</style>
